function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/** These methods may break the react binding if called directly */
var skipMethods = ['setMaxBounds', 'setMinZoom', 'setMaxZoom', 'setMinPitch', 'setMaxPitch', 'setRenderWorldCopies', 'setProjection', 'setStyle', 'addSource', 'removeSource', 'addLayer', 'removeLayer', 'setLayerZoomRange', 'setFilter', 'setPaintProperty', 'setLayoutProperty', 'setLight', 'setTerrain', 'setFog', 'remove'];
export default function createRef(mapInstance, mapLib) {
  if (!mapInstance) {
    return null;
  }

  var map = mapInstance.map;
  var result = {
    getMap: function getMap() {
      return map;
    },
    // Overwrite getters to use our shadow transform
    getCenter: function getCenter() {
      return mapInstance.transform.center;
    },
    getZoom: function getZoom() {
      return mapInstance.transform.zoom;
    },
    getBearing: function getBearing() {
      return mapInstance.transform.bearing;
    },
    getPitch: function getPitch() {
      return mapInstance.transform.pitch;
    },
    getPadding: function getPadding() {
      return mapInstance.transform.padding;
    },
    getBounds: function getBounds() {
      return mapInstance.transform.getBounds();
    },
    project: function project(lnglat) {
      return mapInstance.transform.locationPoint(mapLib.LngLat.convert(lnglat));
    },
    unproject: function unproject(point) {
      return mapInstance.transform.pointLocation(mapLib.Point.convert(point));
    },
    queryTerrainElevation: function queryTerrainElevation(lnglat, options) {
      // @ts-ignore transform not defined
      var tr = map.transform; // @ts-ignore transform not defined

      map.transform = mapInstance.transform;
      var result = map.queryTerrainElevation(lnglat, options); // @ts-ignore transform not defined

      map.transform = tr;
      return result;
    }
  };

  var _iterator = _createForOfIteratorHelper(getMethodNames(map)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;

      // @ts-expect-error
      if (!(key in result) && !skipMethods.includes(key)) {
        result[key] = map[key].bind(map);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

function getMethodNames(obj) {
  var result = new Set();
  var proto = obj;

  while (proto) {
    var _iterator2 = _createForOfIteratorHelper(Object.getOwnPropertyNames(proto)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;

        if (key[0] !== '_' && typeof obj[key] === 'function' && key !== 'fire' && key !== 'setEventedParent') {
          result.add(key);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    proto = Object.getPrototypeOf(proto);
  }

  return Array.from(result);
}